import { useTranslation } from 'react-i18next';

import { createFileRoute } from '@tanstack/react-router';
import { titleWrapper } from '~/utils/title';

export const Route = createFileRoute('/_auth/_main-navigation/unauthorized/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <title>{titleWrapper(t('unauthorized_page.url_title'))}</title>
      <div className="flex min-h-dvh items-center justify-center">
        {t('access_denied')}
      </div>
    </>
  );
}
